import React from "react";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHeart,
  faComment,
  faPaperPlane,
} from "@fortawesome/free-solid-svg-icons";

export default function ProductDetail() {
  const product = JSON.parse(localStorage.getItem("currentProduct"));
  console.log(product);
  const [like, setLike] = React.useState(false);
  const [likeNumber, setLikeNumber] = React.useState(0);
  return (
    <Card className="w-full my-2 h-[78vh]">
      <CardMedia
        component="img"
        height="100%"
        className="rounded-md"
        image={product.image[0]}
        alt={product.name}
      />
      <CardContent className="flex flex-row">
        <Typography
          variant="body"
          color="text.secondary"
          className="flex-1 "
          sx={{
            overflowWrap: "break-word",
            color: "black",
            fontWeight: "bold",
          }}
        >
          {product?.name}
        </Typography>
        {product?.tag && (
          <div className="bg-black justify-center text-center items-center rounded-md text-white text-[0.6rem] w-[15vw] h-fit py-[0.3rem]">
            {product.tag}
          </div>
        )}
      </CardContent>
      <CardActions disableSpacing className="flex  justify-between ">
        <div className="ml-2 flex flex-col">
          <Typography
            variant="body"
            color="text.secondary"
            className="flex-1 "
            sx={{
              overflowWrap: "break-word",
              color: "black",
              fontSize: "0.8rem",
              fontWeight: "bold",
            }}
          >
            ${product?.price} - {product?.category}
          </Typography>

          <div className="mt-1 flex flex-row items-center">
            <Avatar
              src={product?.user?.image}
              aria-label={product?.user?.name}
              sx={{
                width: "1.5rem",
                height: "1.5rem",
              }}
            />
            <p className="text-[0.6rem] text-black ml-2">
              {product?.user?.name}
            </p>
          </div>
        </div>
        <div>
          <IconButton
            className="flex flex-col "
            aria-label="like"
            onClick={() => {
              if (like) {
                setLikeNumber(likeNumber - 1);
              }
              if (!like) {
                setLikeNumber(likeNumber + 1);
              }
              setLike(!like);
            }}
          >
            {like ? (
              <FontAwesomeIcon
                icon={faHeart}
                className=" text-red-500"
                width={20}
              />
            ) : (
              <FontAwesomeIcon icon={faHeart} width={20} />
            )}
            <p className="text-[0.6rem] text-black">Love</p>
          </IconButton>
          <IconButton aria-label="share" className="flex flex-col">
            <FontAwesomeIcon icon={faComment} width={20} />
            <p className="text-[0.6rem] text-black">Comment</p>
          </IconButton>
          <IconButton aria-label="share" className="flex flex-col">
            <FontAwesomeIcon icon={faPaperPlane} width={20} />
            <p className="text-[0.6rem] text-black">Share</p>
          </IconButton>
        </div>
      </CardActions>

      <CardActions className="-mt-1">
        <button className="w-full h-[3rem] bg-red-600 text-white text-[0.8rem] font-bold rounded-lg">
          Add to cart
        </button>
      </CardActions>

      <div className="h-[1px] w-full bg-gray-300 mt-1"></div>
    </Card>
  );
}
